import { useResourceData } from '@/features/resource/contexts/ResourceDataContext'
import ResourceGeneralPage from '@/features/resource/pages/ResourceGeneralPage'

function ResourceDetailsIndex() {
  const { resource } = useResourceData()

  // Hold off until the resource arrives. ResourceGeneralCard returns null in that state anyway, so
  // this is not what prevents a flash — it keeps the index's own contract explicit: it renders a page
  // only once there is a resource to render it for.
  if (!resource) {
    return null
  }

  // General is the landing tab for every role and both control modes. LOCAL admins/traders used to
  // be redirected to /configuration from here, which left the activation-groups overview (and its
  // Activatable column) unreachable for them once the LOCAL/CLOUD tab strips were split. The
  // Resource configuration tab is one click away in LocalResourceTabs.
  return <ResourceGeneralPage />
}

export default ResourceDetailsIndex
